module.exports = "/_next/static/images/3300b2b03565e6afc899499bd01dea36-blog2-xs.png";